import { inject } from '@angular/core'
import { signalStore, withMethods } from '@ngrx/signals'
import { rxMethod } from '@ngrx/signals/rxjs-interop'
import { I18nApi } from '@core/i18n/i18n.api'
import { parseLangFromISO } from '@core/i18n/i18n.utils'
import { TranslateService } from '@ngx-translate/core'
import { of } from 'rxjs'
import { catchError, switchMap, tap } from 'rxjs/operators'
import { PrimeNGConfig } from '@shared/modules/primeng-clone/api'

export const I18nStore = signalStore(
  { providedIn: 'root' },
  withMethods(() => {
    const api = inject(I18nApi)
    const translate = inject(TranslateService)
    const config = inject(PrimeNGConfig)

    const setPrimengTranslations = () =>
      translate.get('MTR_PRIMENG').subscribe((translations) => config.setTranslation(translations))

    return {
      fetchTranslations: rxMethod<string>((source$) =>
        source$.pipe(
          tap((lang) => translate.use(parseLangFromISO(lang))),
          switchMap((lang) =>
            api.fetchTranslations(lang).pipe(
              tap(({ translations }) => {
                translate.setTranslation(parseLangFromISO(lang), translations, true)
                setPrimengTranslations()
              }),
              catchError((err) => {
                console.error('Unable to fetch translations', err)
                return of(undefined)
              }),
            ),
          ),
        ),
      ),
    }
  }),
)
